import React from 'react'
import { AppFooter } from '@connectcore/connect-components-react'
import { COPYRIGHT_INFO } from '~utils/constants'
import './footer.scss'
const Footer = () => {
  return (
    <div>
      <AppFooter>
        <div className="row align-content-center w-100">
          <div className="footer-links col-12 col-md-7 col-xl-6 m-auto">
            <ul className="px-0">
              <li>
                <a href="https://www.jpmorgan.com/country/US/EN/privacy">Privacy & Security</a>
              </li>
              <li>
                <a href="https://www.jpmorgan.com/country/US/EN/terms">Terms of Use</a>
              </li>
              <li>
                <a href="https://www.jpmorgan.com/country/US/EN/disclosures">
                  Regulatory Disclosures
                </a>
              </li>
              <li>
                <a href="https://www.jpmorgan.com/country/US/EN/cookies">Cookies Policy</a>
              </li>
            </ul>
          </div>
          <div className="copyright col-12 col-md-5 col-xl-6">
            <p className="m-auto">&copy; {COPYRIGHT_INFO}</p>
          </div>
        </div>
      </AppFooter>
    </div>
  )
}

export default Footer
